import LetsTalk from '@/components/promo/LetsTalk';

export default function Contact() {
  return (
    <div style={{ paddingTop: 48 }}>
      <LetsTalk />
    </div>
  );
}
